<script>
import EmojiInput from 'shared/components/emoji/EmojiInput.vue';

const QUICK_REACTIONS = ['👏', '👍', '😊', '❤️', '👌', '😂'];

export default {
  name: 'MessageReactionBar',
  components: {
    EmojiInput,
  },
  props: {
    variant: {
      type: String,
      default: 'dark',
      validator: value => ['dark', 'light'].includes(value),
    },
    pickerAlign: {
      type: String,
      default: 'right',
      validator: value => ['left', 'right'].includes(value),
    },
  },
  emits: ['select'],
  data() {
    return {
      showPicker: false,
      quickReactions: QUICK_REACTIONS,
    };
  },
  computed: {
    moreReactionsLabel() {
      return 'More reactions';
    },
  },
  methods: {
    handleSelect(emoji) {
      this.$emit('select', emoji);
      this.showPicker = false;
    },
    togglePicker() {
      this.showPicker = !this.showPicker;
    },
  },
};
</script>

<template>
  <div
    class="reaction-bar-wrap"
    :class="[`is-${variant}`, `is-picker-${pickerAlign}`]"
    @click.stop
  >
    <div class="reaction-quick-bar">
      <button
        v-for="emoji in quickReactions"
        :key="emoji"
        type="button"
        class="reaction-button"
        @click="handleSelect(emoji)"
      >
        {{ emoji }}
      </button>
      <button
        type="button"
        class="reaction-button reaction-more"
        :aria-label="moreReactionsLabel"
        @click="togglePicker"
      />
    </div>
    <div v-if="showPicker" class="reaction-picker">
      <EmojiInput :on-click="handleSelect" show-remove-button />
    </div>
  </div>
</template>

<style scoped lang="scss">
.reaction-bar-wrap {
  @apply relative inline-flex z-30;
}

.reaction-quick-bar {
  @apply inline-flex items-center h-8 rounded-lg shadow-lg ring-1 overflow-hidden;
}

.reaction-button {
  @apply flex items-center justify-center w-8 h-8 p-0 m-0 bg-transparent border-0 text-base leading-none cursor-pointer transition-colors;
}

.reaction-more {
  @apply text-lg tracking-tighter;
}

.reaction-bar-wrap.is-dark {
  .reaction-quick-bar {
    @apply bg-[#1B1F23] ring-[#8C8C8C]/25;
  }

  .reaction-button {
    @apply hover:bg-white/10;
  }

  .reaction-more {
    @apply text-white/90;
  }
}

.reaction-bar-wrap.is-light {
  .reaction-quick-bar {
    @apply bg-white ring-n-slate-4 shadow-[0_8px_24px_rgba(15,23,42,0.16)];
  }

  .reaction-button {
    @apply hover:bg-n-slate-2;
  }

  .reaction-more {
    @apply text-n-slate-12;
  }
}

.reaction-more::before {
  content: '...';
}

.reaction-picker {
  @apply absolute right-0 top-10 z-40;
}

.reaction-bar-wrap.is-picker-right .reaction-picker {
  @apply right-0 left-auto;
}

.reaction-bar-wrap.is-picker-left .reaction-picker {
  @apply left-0 right-auto;
}

.reaction-bar-wrap.is-picker-right .reaction-picker :deep(.emoji-dialog) {
  @apply right-0 top-0;
}

.reaction-bar-wrap.is-picker-left .reaction-picker :deep(.emoji-dialog) {
  @apply left-0 right-auto top-0;
}

.reaction-picker :deep(.emoji-dialog) {
  max-width: calc(100vw - 1.5rem);
}

.reaction-picker :deep(.emoji-dialog::before) {
  @apply hidden;
}
</style>
